<div class="flex flex-col h-[400px] sm:h-[500px] lg:h-[600px] bg-white rounded-lg shadow-lg overflow-hidden">
  <!-- Header del chat -->
  <div class="flex-shrink-0">
    <app-chat-header [repartidor]="repartidor()" [idDelivery]="receiverId()" [picture_delivery]="picture_delivery"></app-chat-header>
  </div>

  <!-- Lista de mensajes con scroll -->
  <div class="flex-1 overflow-hidden">
    <app-chat-messages-list #chatMessagesList
      [messages]="messageHistory()"
      [isTyping]="typing()">
    </app-chat-messages-list>
  </div>

  <!-- Input para escribir mensajes -->
  <div class="flex-shrink-0">
    <app-chat-input
      [senderId]="authService.getUser()?.ua_id || 0"
      [receiverId]="receiverId()"
      [orderId]="orderId"
      (messageSent)="onSendMessage($event)"
      (typing)="onTyping($event)"
      (messageCliRep)="onMessageCliRep($event)"
      (fileSelected)="onFileSelected($event)">
    </app-chat-input>
  </div>
</div>
